import React from 'react'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import PropTypes from 'prop-types'

const Radio = ({ disabled, name, value, checked, onChange, onClick, children, invitationMode }) => {
  const classes = useStyles({ checked, disabled })

  const id = `${name}_${value}`
  const alreadyConnectedText = lang.createClient.connection.alreadyConnected

  return (
    <label htmlFor={id} className={classes.label}>
      <div className={classes.alreadyConnected}>
        {disabled && alreadyConnectedText && !invitationMode}
      </div>
      <input
        className={classes.input}
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={disabled ? false : checked}
        onChange={disabled ? null : onChange}
        onClick={disabled ? null : onClick}
      />
      {children}
    </label>
  )
}

const useStyles = makeStyles((theme) => ({
  label: ({ checked, disabled }) => ({
    position: 'relative',
    height: 80,
    padding: '0 20px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    border: `1px solid ${checked && !disabled ? theme.primary : theme.borderColor}`,
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.borderRadius,
    '&:hover': {
      cursor: disabled ? 'not-allowed' : 'pointer',
      borderColor: disabled ? theme.borderColor : theme.primary,
    },
    '& + $label': {
      marginTop: 20,
    },
    '.title': {
      fontSize: theme.fontSizes.default,
      fontWeight: theme.fontWeights.medium,
      lineHeight: '1.86',
      letterSpacing: '0.14px',
      color: '#215999',
    },
  }),
  input: {
    marginRight: 20,
  },
  alreadyConnected: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    background: 'white',
    opacity: ({ disabled }) => disabled ? '0.7' : '0',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

Radio.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  invitationMode: PropTypes.bool,
}
Radio.defaultProps = {
  onClick: () => {},
  invitationMode: false,
  disabled: false,
}

export default Radio
